import { useEffect } from 'react'
import { company } from '../../data/siteData'

function upsertMeta(name, content) {
  let tag = document.querySelector(`meta[name="${name}"]`)

  if (!tag) {
    tag = document.createElement('meta')
    tag.setAttribute('name', name)
    document.head.appendChild(tag)
  }

  tag.setAttribute('content', content)
}

function SEO({ title, description }) {
  useEffect(() => {
    document.title = title ? `${title} | ${company.name}` : company.name
    upsertMeta('description', description)
  }, [description, title])

  return null
}

export default SEO
